<div #mapViewNode [style.height]="bodyHeightAsString$ | async"></div>

<div
  style="visibility: hidden; position: fixed"
  [style.left]="menuTopLeftPosition.x"
  [style.top]="menuTopLeftPosition.y"
  [matMenuTriggerFor]="rightMenu"
></div>

<!-- standard material menu -->
<mat-menu #rightMenu xPosition="after" yPosition="below">
  <ng-template matMenuContent let-item="item">
    <!-- <button mat-menu-item *ngIf="item && item > -1" (click)="selectSegment(item)">Sélectionner le tronçon {{ item }}</button> -->

    <button mat-menu-item *ngIf="!esDeclared && highlightedSegment" (click)="declareEs(item)">Déclarer un ES à cet endroit</button>
    <div mat-menu-item *ngIf="menuLoading" fxLayout="row" fxLayoutAlign="center center">
      <mat-spinner color="accent" diameter="48"></mat-spinner>
    </div>
    <button mat-menu-item *ngIf="esDeclared && esDeclared.id > -1" (click)="editEs()">Editer</button>
    <button mat-menu-item *ngIf="esDeclared && esDeclared.id > -1" (click)="deleteEs()">Terminer</button>
    <button mat-menu-item (click)="reset()">Annuler</button>
  </ng-template>
</mat-menu>

<section class="bottom-ui">
  <button color="primary" mat-raised-button (click)="applyEfp()">Vérifier l'applicabilité</button>
  <mat-spinner style="margin-left: 10px" color="accent" [diameter]="20" *ngIf="loading$ | async"></mat-spinner>
</section>

<app-subsystem-report [open]="openRepports" [bodyHeight]="bodyHeight$ | async" (applied)="applyPgm()"></app-subsystem-report>

<!-- <app-flying-container #esInfoComponent [item]="EsInfoComponent"></app-flying-container> -->
